// extracted by mini-css-extract-plugin
module.exports = {"row":"dd31006766--row--dfEJM","mobile":"dd31006766--mobile--Zcfgi"};